<template>
  <div class="bg-brand-taupe-500">
    <PageHeader :headingContent="headingContent" />
    <div class="pb-20">
      <div class="container mx-auto mb-4 rounded-md bg-brand-taupe-100 p-6">
        <flash-messages />
        <div class="px-4 gap-4">
          <p class="mb-4">
            Log in to create or review your Fleet Risk Reviews below. If you've forgotton
            your password please use the "Forgot your password" link below the login
            fields to reset it.
          </p>
         
          <p>
          </p>
        </div>
        <form class="px-4 flex flex-wrap gap-4" @submit.prevent autocomplete="off">
          <div class="flex flex-wrap items-center w-full">
            <div class="w-1/3">
              <label for="email" class="font-semibold text-brand-blue-400">Email</label>
            </div>
            <div class="w-2/3">
              <input
                class="w-full border-gray-300 px-2 py-1 bg-white-100 border-2"
                id="email"
                type="text"
                v-model="form.email"
                autocomplete="off"
              />
            </div>
            <div
              v-if="$attrs.errors.email"
              class="border-2 border-red-500 bg-red-300 w-full px-2 py-1 text-gray-900 text-sm"
            >
              {{ $attrs.errors.email }}
            </div>
          </div>
          <div class="flex flex-wrap items-center w-full">
            <div class="w-1/3">
              <label for="password" class="font-semibold text-brand-blue-400"
                >Password</label
              >
            </div>
            <div class="w-2/3">
              <input
                class="w-full border-gray-300 px-2 py-1 bg-white-100 border-2"
                id="password"
                type="password"
                v-model="form.password"
                autocomplete="off"
              />
            </div>
            <div
              v-if="$attrs.errors.password"
              class="border-2 border-red-500 bg-red-300 w-full px-2 py-1 text-gray-900 text-sm"
            >
              {{ $attrs.errors.password }}
            </div>
          </div>
          <div class="flex justify-between w-full">
            <Link class="text-brand-blue-500 hover:text-blue-500" href="/forgot-password">
              Forgot your password?
            </Link>
            <button
              class="bg-brand-blue-400 hover:bg-brand-blue-200 text-white font-bold py-2 px-4 mr-2 rounded uppercase"
              @click="form.post('/login', { preserveState: true })"
            >
              Login
            </button>
          </div>
        </form>
        <br/><br/>
        <div class="px-4 gap-4">
        <p>
          If you don't have login details yet please contact your local AXA Fleet team to arrange an invitation to register for your free risk management health check.
        </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/Shared/PageHeader";
import { useForm } from "@inertiajs/inertia-vue3";
import FlashMessages from "@/Shared/FlashMessages";

export default {
  components: {
    PageHeader,
    FlashMessages,
  },
  name: "Login",
  setup() {
    const form = useForm({
      email: "",
      password: "",
    });
    const headingContent = {
      hero: {
        image: "/images/263918963_cars_hero.jpg",
        title: "Fleet Risk Review",
        subtitle: "In association with AXA Insurance",
      },
      page: {
        title: "Log in",
        subtitle: "",
      },
    };
    return {
      form,
      headingContent,
    };
  },
};
</script>
